import { makeStyles } from "@material-ui/core/styles";
import { DeliveryTypeEnum as DelEnum } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

export interface StoreOrderDeliveryTypeProps {
  delType: DelEnum | null;
}

const useStyles = makeStyles(
  {
    delTypeExpress: {
      backgroundColor: "#F1996F"
    },
    delTypeExpressLong: {
      backgroundColor: "#E3167D"
    },
    delTypeInMall: {
      backgroundColor: "#1D57A5"
    },
    delTypeNationwide: {
      backgroundColor: "#EAE6FF",
      color: "#403294 !important"
    },
    delTypeNextDay: {
      backgroundColor: "#6DAB64"
    },
    delTypeSameDay: {
      backgroundColor: "#6051E3"
    },
    deliveryHolder: {
      color: "#ffffff",
      padding: "5px"
    }
  },
  { name: "StoreOrderDeliveryType" }
);

const StoreOrderDeliveryType: React.FC<StoreOrderDeliveryTypeProps> = ({
  delType
}) => {
  const classes = useStyles({});

  let newLabel = "";
  let newStyle = "";

  switch (delType) {
    case DelEnum.EXPRESS:
      newLabel = "Express Delivery";
      newStyle = classes.delTypeExpress;
      break;
    case DelEnum.IN_STORE_PICKUP:
      newLabel = "In-Store Pick Up";
      newStyle = classes.delTypeInMall;
      break;
    case DelEnum.NEXT_DAY:
      newLabel = "Standard Delivery";
      newStyle = classes.delTypeNextDay;
      break;
    case DelEnum.SAME_DAY:
      newLabel = "Same Day Delivery";
      newStyle = classes.delTypeSameDay;
      break;
    case DelEnum.EXPRESS_LONG_DISTANCE:
      newLabel = "10km Express Delivery";
      newStyle = classes.delTypeExpressLong;
      break;
    case DelEnum.NATIONWIDE_DELIVERY:
      newLabel = "Nationwide Delivery";
      newStyle = classes.delTypeNationwide;
      break;
    default:
      break;
  }

  return (
    <>
      <span className={classNames(newStyle, classes.deliveryHolder)}>
        {newLabel}
      </span>
    </>
  );
};

export default StoreOrderDeliveryType;
